module.exports = __webpack_public_path__ + "static/img/diariobg.1ba36a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/PMVG/diariobg.jpg
// module id = HqUf
// module chunks = 1